import { cn } from '@/lib/utils';
// The Next page imports the admin printing page's card component verbatim
// (app/admin/(protected)/misc/26-mx/credentials/_components/unified-credential-card), so
// the port does the same rather than growing a second copy of the design.
import { CredentialCardView } from '@/pages/Admin/Misc/Credentials/components/CredentialCardView';
import type { HackerCredentialsShow } from '@/types';
import { CredentialUrlForm } from './components/CredentialUrlForm';

// /:event_slug/hacker/credential — the 26-ar and 26-mx twins as one page (PORTING.md G5).
// The card is the very component the admin printing page uses; only its design config
// and the QR host change between editions.
export default function Show({
  card,
  designCard,
  dateLabel,
  cityLabel,
  sponsorsAsset,
  cardFootMarginTop,
  currentUrl,
  customAllowed,
  eventEndsAt,
  idHostSlug,
  titleFont,
  intro,
  customHint,
  dateLocale,
}: HackerCredentialsShow) {
  const design = {
    card: designCard,
    dateLabel,
    cityLabel,
    sponsorsAsset,
    cardFootMarginTop,
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="mx-auto w-full max-w-5xl space-y-8">
          <div>
            <h1
              className={cn(
                'font-bold text-3xl text-primary sm:text-4xl',
                titleFont,
              )}
            >
              Tu credencial
            </h1>
            <p className="mt-2 font-mono text-primary/70 text-sm">{intro}</p>
          </div>

          <div className="grid gap-8 md:grid-cols-2">
            <div className="flex justify-center">
              <div
                style={{
                  transform: 'scale(0.6)',
                  transformOrigin: 'top center',
                  width: '535px',
                  height: '510px',
                }}
              >
                <CredentialCardView card={card} design={design} />
              </div>
            </div>

            <div className="border-2 border-primary bg-background/80 p-6 backdrop-blur-sm">
              <CredentialUrlForm
                action={`/${idHostSlug}/hacker/credential`}
                currentUrl={currentUrl}
                customAllowed={customAllowed}
                eventEndsAt={eventEndsAt}
                idHostSlug={idHostSlug}
                customHint={customHint}
                dateLocale={dateLocale}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
